export const adminPermission = {
  addColumn: true,
};
